import { z } from 'zod';

export const NewsStatus = z.enum(['PUBLISHED', 'HIDDEN']);
export type NewsStatus = z.infer<typeof NewsStatus>;

export const NewsDto = z.object({
  id: z.uuid(),
  title: z.string(),
  body: z.string(),
  coverUrl: z.string().nullable(),
  imageUrls: z.array(z.string()),
  sourceUrl: z.string(),
  authorName: z.string().nullable(),
  cityId: z.uuid(),
  publishedAt: z.iso.datetime(),
  likeCount: z.number().int().nonnegative(),
  isLikedByMe: z.boolean(),
});
export type NewsDto = z.infer<typeof NewsDto>;

export const NewsAdminUpdateInput = z
  .object({
    status: NewsStatus.optional(),
  })
  .strip();
export type NewsAdminUpdateInput = z.infer<typeof NewsAdminUpdateInput>;
